import Index from '@/views/index'
import jdyrole from '@/common/jdyrole'
export const ecology = {
  path: '/ecology',
  redirect: '/ecology/product/index',
  component: Index,
  name: 'ecology',
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/ecology/product/index',
      components: {
        default: () => import('@/views/ecology/product/index')
      },
      name: 'product-list',
      meta: {
        requiresAuth: true,
        title: '筋斗云-产品管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/wezhan/product-add',
      components: {
        default: () => import('@/views/ecology/product/wezhan/product-add')
      },
      name: 'wezhan-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增产品',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/wezhan/index',
      components: {
        default: () => import('@/views/ecology/product/wezhan/index')
      },
      name: 'wezhan-index',
      meta: {
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager],
        title: '筋斗云-产品管理'
      }
    },
    {
      path: '/ecology/product/wezhan/pvariant-edit',
      components: {
        default: () => import('@/views/ecology/product/wezhan/pvariant-edit')
      },
      name: 'wezhan-pvariant-edit',
      meta: {
        requiresAuth: true,
        title: '筋斗云-编辑版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/wezhan/pvariant-add',
      components: {
        default: () => import('@/views/ecology/product/wezhan/pvariant-add')
      },
      name: 'wezhan-pvariant-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/domain/product-add',
      components: {
        default: () => import('@/views/ecology/product/domain/product-add')
      },
      name: 'domain-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增产品',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/domain/index',
      components: {
        default: () => import('@/views/ecology/product/domain/index')
      },
      name: 'domain-index',
      meta: {
        requiresAuth: true,
        title: '产品管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/domain/pvariant-edit',
      components: {
        default: () => import('@/views/ecology/product/domain/pvariant-edit')
      },
      name: 'domain-pvariant-edit',
      meta: {
        requiresAuth: true,
        title: '编辑版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/domain/pvariant-add',
      components: {
        default: () => import('@/views/ecology/product/domain/pvariant-add')
      },
      name: 'domain-pvariant-add',
      meta: {
        requiresAuth: true,
        title: '新增版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/slb/product-add',
      components: {
        default: () => import('@/views/ecology/product/slb/product-add')
      },
      name: 'slb-add',
      meta: {
        requiresAuth: true,
        title: '添加版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/slb/index',
      components: {
        default: () => import('@/views/ecology/product/slb/index')
      },
      name: 'slb-index',
      meta: {
        requiresAuth: true,
        title: '产品管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/slb/pvariant-edit',
      components: {
        default: () => import('@/views/ecology/product/slb/pvariant-edit')
      },
      name: 'slb-pvariant-edit',
      meta: {
        requiresAuth: true,
        title: '产品编辑',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/slb/pvariant-add',
      components: {
        default: () => import('@/views/ecology/product/slb/pvariant-add')
      },
      name: 'slb-pvariant-add',
      meta: {
        requiresAuth: true,
        title: '编辑版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/clouddreamworks/product-add',
      components: {
        default: () =>
          import('@/views/ecology/product/clouddreamworks/product-add')
      },
      name: 'clouddreamworks-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增产品',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/clouddreamworks/index',
      components: {
        default: () => import('@/views/ecology/product/clouddreamworks/index')
      },
      name: 'clouddreamworks-index',
      meta: {
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager],
        title: '筋斗云-产品管理'
      }
    },
    {
      path: '/ecology/product/clouddreamworks/pvariant-edit',
      components: {
        default: () =>
          import('@/views/ecology/product/clouddreamworks/pvariant-edit')
      },
      name: 'clouddreamworks-pvariant-edit',
      meta: {
        requiresAuth: true,
        title: '筋斗云-编辑版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/clouddreamworks/pvariant-add',
      components: {
        default: () =>
          import('@/views/ecology/product/clouddreamworks/pvariant-add')
      },
      name: 'clouddreamworks-pvariant-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product-series/list',
      components: {
        default: () => import('@/views/ecology/product-series/list')
      },
      name: 'product-series',
      meta: {
        requiresAuth: true,
        title: '筋斗云-产品系列管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product-series/add',
      components: {
        default: () => import('@/views/ecology/product-series/add')
      },
      name: 'product-series-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增产品系列',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product-series/edit',
      components: {
        default: () => import('@/views/ecology/product-series/edit')
      },
      name: 'product-series-edit',
      meta: {
        requiresAuth: true,
        title: '筋斗云-编辑产品系列',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/newwezhan/product-add',
      components: {
        default: () => import('@/views/ecology/product/newwezhan/product-add')
      },
      name: 'newwezhan-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增产品',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/newwezhan/index',
      components: {
        default: () => import('@/views/ecology/product/newwezhan/index')
      },
      name: 'newwezhan-index',
      meta: {
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager],
        title: '筋斗云-产品管理'
      }
    },
    {
      path: '/ecology/product/newwezhan/pvariant-edit',
      components: {
        default: () => import('@/views/ecology/product/newwezhan/pvariant-edit')
      },
      name: 'newwezhan-pvariant-edit',
      meta: {
        requiresAuth: true,
        title: '筋斗云-编辑版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product/newwezhan/pvariant-add',
      components: {
        default: () => import('@/views/ecology/product/newwezhan/pvariant-add')
      },
      name: 'newwezhan-pvariant-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增版本',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product-plugin/list',
      components: {
        default: () => import('@/views/ecology/product-plugin/list')
      },
      name: 'product-plugin-list',
      meta: {
        requiresAuth: true,
        title: '筋斗云-插件管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product-plugin/add',
      components: {
        default: () => import('@/views/ecology/product-plugin/add')
      },
      name: 'product-plugin-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新增插件',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/product-plugin/edit',
      components: {
        default: () => import('@/views/ecology/product-plugin/edit')
      },
      name: 'product-plugin-edit',
      meta: {
        requiresAuth: true,
        title: '筋斗云-修改插件',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/new-product-series/list',
      components: {
        default: () => import('@/views/ecology/new-product-series/list')
      },
      name: 'newwezhan-product-series',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新微站产品系列管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/new-product-series/add',
      components: {
        default: () => import('@/views/ecology/new-product-series/add')
      },
      name: 'newwezhan-product-series-add',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新微站新增产品系列',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/new-product-series/edit',
      components: {
        default: () => import('@/views/ecology/new-product-series/edit')
      },
      name: 'newwezhan-product-series-edit',
      meta: {
        requiresAuth: true,
        title: '筋斗云-新微站编辑产品系列',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/componentManage',
      components: {
        default: () => import('@/views/ecology/component-manage/category-list')
      },
      name: 'componentManage',
      meta: {
        requiresAuth: true,
        title: '筋斗云-语义化组件管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/component-list',
      components: {
        default: () => import('@/views/ecology/component-manage/comp-list/index.vue')
      },
      name: 'componentList',
      meta: {
        title: '筋斗云-语义化组件列表',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    },
    {
      path: '/ecology/column-manage',
      components: {
        default: () => import('@/views/ecology/column-manage/index.vue')
      },
      name: 'cloumnManage',
      meta: {
        title: '筋斗云-栏目内容管理',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    }

  ]
}



// WEBPACK FOOTER //
// ./src/router/ecology/index.js